<script lang="ts">
  import { Col, Container, Form, FormGroup, Image, Input, Row } from "sveltestrap";
  import { HowCanIhelpyou } from "../../../../utils/Constant/Constant";
  import FeatherIcons from "svelte-feather-icon";
  import FaqHeadContent from "../../FAQ/FaqHeadContent.svelte";
  import BookmarkKnowledgeCategory from "./BookmarkKnowledgeCategory.svelte";
  import BrowserArtical from "./BrowserArtical.svelte";
  let imgPath:string = "/assets/images/knowledgebase"

</script>
<BookmarkKnowledgeCategory />
<Container fluid>
    <Row>
      <Col xs="12">
        <div class="knowledgebase-bg">
          <Image class="bg-img-cover bg-center w-100" src="{imgPath}/bg_1.jpg" alt="looginpage" />
        </div>
        <div class="knowledgebase-search">
          <div>
            <h3>{HowCanIhelpyou}</h3>
            <Form class="form-inline" action="#" method="get">
              <FormGroup class="w-100">
                <FeatherIcons icon="search" />
                <Input
                  class="form-control-plaintext"
                  type="text"
                  placeholder="Type question here" />
              </FormGroup>
            </Form>
          </div>
        </div> 
      </Col>
      <FaqHeadContent />
      <BrowserArtical />
    </Row>
</Container>